import Modal from '@/components/Modal/Modal'
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ViewLocation from "@/components/ViewLocation/ViewLocation";
import { useState } from 'react';
import { getUserGeofenceAreaById } from "@/store/slices/GeofenceManagementSlice";
import toast from "@/lib/toast";
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '@/store/store';


interface IUserGeofences {
    UserGeofencesModalOpen: boolean;
    UserGeofencesCloseModal: () => void;
    selectedUser: any;
    geoFencingArea: any[];
}
const UserGeofences = ({ UserGeofencesModalOpen, UserGeofencesCloseModal, selectedUser, geoFencingArea }: IUserGeofences) => {
    const [location, setLocation] = useState({ lat: "", lng: "" });
    const [modalOpenViewLocation, setModalOpenViewLocation] = useState(false);

    const label = `User Geofences - ${selectedUser?.UserName || ""}`;

    const inGeofences = selectedUser?.PunchInGeoFences || [];
    const outGeofences = selectedUser?.PunchOutGeoFences || [];
    const dispatch = useDispatch<AppDispatch>();

    const handleOnClickLocation = async (geofence: any) => {
        try {
            // coordinates already available on the object
            if (geofence?.Latitude != null && geofence?.Longitude != null) {
                setLocation({
                    lat: String(geofence.Latitude),
                    lng: String(geofence.Longitude),
                });
                setModalOpenViewLocation(true);
                return;
            }
            const localArea = geoFencingArea?.find(
                (g: any) => g.Id === geofence.Id
            );

            if (localArea?.Latitude != null && localArea?.Longitude != null) {
                setLocation({
                    lat: String(localArea.Latitude),
                    lng: String(localArea.Longitude),
                });
                setModalOpenViewLocation(true);
                return;
            }

            const area: any = await dispatch(
                getUserGeofenceAreaById(geofence.Id)
            ).unwrap();

            if (area?.Latitude != null && area?.Longitude != null) {
                setLocation({
                    lat: String(area.Latitude),
                    lng: String(area.Longitude),
                });
                setModalOpenViewLocation(true);
                return;
            }

            toast.error("Coordinates not available for this geofence");
        } catch (error: any) {
            toast.error(error || "Failed to load geofence location");
        }
    };

    return (
        <Modal
            modalOpen={UserGeofencesModalOpen}
            closeModal={UserGeofencesCloseModal}
            heading={label}
            hideAddButton
            width="350px"
        >
            <div style={{ display: "flex", flexDirection: "column", gap: 20, padding: "4px 0 8px" }}>
                {[
                    { label: "Punch in", items: inGeofences },
                    { label: "Punch out", items: outGeofences },
                ].map(({ label, items }) => (
                    <div key={label}>
                        <p style={{ fontSize: 11, fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.6px", color: "var(--color-text-secondary)", margin: "0 0 8px" }}>
                            {label}
                        </p>
                        {items.length === 0 ? (
                            <Typography variant="body2" color="text.secondary" sx={{ padding: "7px 2px" }}>
                                No {label.toLowerCase()} geofences assigned
                            </Typography>
                        ) : (
                            <Stack spacing={0.75}>
                                {items.map((geofence: any, index: number) => (
                                    <div
                                        onClick={() => handleOnClickLocation(geofence)}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                            cursor: "pointer",
                                            width: "fit-content",
                                        }}

                                    >
                                        <LocationOnOutlinedIcon
                                            sx={{
                                                fontSize: 16,
                                                color: "text.secondary",
                                                borderRadius: "50%",
                                                transition: "color 0.2s ease, background-color 0.2s ease, transform 0.2s ease",
                                                "&:hover": {
                                                    color: "primary.main",
                                                    bgcolor: "primary.50",
                                                    transform: "scale(1.1)",
                                                },
                                            }}
                                        />
                                        <Typography variant="body2" sx={{
                                            transition: "color 0.2s ease", "&:hover": { color: "primary.main", },
                                        }}>
                                            {geofence.Name} {geofence?.GeoFenceTypeName ? `(${geofence?.GeoFenceTypeName})` : ""}
                                        </Typography>
                                    </div>
                                ))}
                            </Stack>
                        )}
                    </div>
                ))}
            </div>

            {modalOpenViewLocation && (
                <ViewLocation
                    title="Location"
                    width="800px"
                    modalOpen={modalOpenViewLocation}
                    closeModal={() => setModalOpenViewLocation(false)}
                    lat={location.lat}
                    lng={location.lng}
                />
            )}
        </Modal>
    )
}

export default UserGeofences
